import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  meta: {
    pageNumber: 1,
    pageSize: 100,
    itemTotal: 0,
  },
  list: [],
  reports: [],
  selectedBankRate: {
    bank: {
      _id: undefined,
    },
  },
  bankRateAdded: false,
  bankRateUpdated: false,
  bankRateRemoved: false,
};

const bankRatesSlice = createSlice({
  name: "bankRates",
  initialState,
  reducers: {
    getBankRates(state, action) {
      state.list = action.payload.interestRates;
      state.meta = action.payload.meta;
    },
    getBankRateById(state, action) {
      state.selectedBank = action.payload;
    },
    addBankRates(state, action) {
      state.bankRateAdded = true;
    },
    updateBankRates(state, action) {
      state.bankRateUpdated = true;
    },
    removeBankRates(state, action) {
      state.bankRateRemoved = true;
    },
    reset: (state) => initialState,
    logout: (state) => initialState,
  },
});

export const bankRatesActions = bankRatesSlice.actions;
export default bankRatesSlice;
